module.exports = __webpack_public_path__ + "static/img/ebbly-login-cn.46a6110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebbly-login-cn.png
// module id = wPYb
// module chunks = 33 34